var styleDataHash = "fbc55378";
const injectCss = () => {
  var css = `@charset "UTF-8";.glob_fontElementMap,.snmKh{font-family:var(--ricos-font-family,unset)}.Q95pu{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;justify-content:center}[dir] .Q95pu{background:transparent;border:0;cursor:pointer;padding:4px}[dir] .Q95pu:hover:not([disabled]){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.Q95pu.NxwVg{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}[dir] .Q95pu.NxwVg{background-color:rgba(var(--ricos-action-color-fallback-tuple,2,97,255),.1)}.Q95pu.NxwVg svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.Q95pu._5OOaB{opacity:.4}[dir] .Q95pu._5OOaB{cursor:default}[dir] .Q95pu.bYQTK:not(.NxwVg):hover{background-color:unset}.Q95pu:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.asTur{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}.asTur.VMopO{height:32px;width:32px}.wMllv{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var ToolbarButton_default = {
  "fontElementMap": "snmKh",
  "toolbarButtonWrapper": "Q95pu",
  "active": "NxwVg",
  "disabled": "_5OOaB",
  "mobileToolbarButtonWrapper": "bYQTK",
  "toolbarButton": "asTur",
  "mobileToolbarButton": "VMopO",
  "iconTextWrapper": "wMllv"
};
export {
  ToolbarButton_default as default,
  injectCss
};
//# sourceMappingURL=ToolbarButton-scss.js.map
